import ApiService from "../api";

export default class AnexoSolicitacaoService extends ApiService {

    constructor() {
        super('/api/solicitacoes')
    }

    /**
     * `onProgresso(percentual)` (opcional) recebe 0–100 conforme os bytes sobem. `inicial`: anexo do
     * formulário de abertura — não entra na linha do tempo da solicitação.
     */
    anexar(solicitacaoId, arquivo, descricao, onProgresso, inicial = false) {
        const formData = new FormData()
        formData.append("arquivo", arquivo)
        formData.append("descricao", descricao)
        formData.append("inicial", inicial)

        return this.post(`/${solicitacaoId}/anexos`, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            },
            onUploadProgress: onProgresso
                ? e => e.total && onProgresso(Math.min(100, Math.round((e.loaded / e.total) * 100)))
                : undefined,
        })
    }

    /** Avisa o backend que um anexo não pôde ser enviado — fica registrado no histórico da solicitação. */
    registrarFalha(solicitacaoId, { nomeArquivo, descricao, tamanhoBytes, erro }) {
        return this.post(`/${solicitacaoId}/anexos/falhas`, { nomeArquivo, descricao, tamanhoBytes, erro })
    }

    substituirArquivo(anexoId, arquivo) {
        const formData = new FormData()
        formData.append("arquivo", arquivo)

        return this.put(`/anexos/${anexoId}/arquivo`, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        })
    }

    listarAnexos(solicitacaoId) {
        return this.get(`/${solicitacaoId}/anexos`)
    }

    baixarAnexo(anexoId) {
        return this.fileDownload(`/anexos/${anexoId}/download`)
    }

    excluirAnexo(anexoId) {
        return this.delete(`/anexos/${anexoId}`)
    }
}
